import React from "react";
import PropTypes from "prop-types";
import "./Accordion.scss";
import MyErrorBoundary from "../../utils/ErrorBoundary";

const ProjectsAccordion = ({ label, children , addItem = false, handleAddItem,defaultOpen = false, totalListLabel="" }) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);
  const onClickLabel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <MyErrorBoundary>

    <div
      className={
        isOpen ? "accordionOpen  mb-1 w-100" : "accordionClose  mb-1 w-100"
      }
      style={{ padding: "0 15px" }}
    >
      <div className="accordionBorder">
        <div
          onClick={onClickLabel}
          className="col-md-12  w-100 py-2 "
          style={{ cursor: "pointer" }}
        >
          <div className="row ">
            <div className={`col-4 `}>
              {!isOpen && <se-icon size="nano">arrow3_down</se-icon>}
              {isOpen && <se-icon size="nano">arrow3_up</se-icon>}
              <span className="ml-3 se-life-green se-font-14px-bold">
                {label}
              </span>
            </div>
            <div className="col-4 text-center">{totalListLabel}</div>
            <div className="col-4 text-right">
            {addItem &&
            <se-icon color="primary" onClick={handleAddItem}>action_add_flat</se-icon>
            }
            </div>
          </div>
        </div>
        {isOpen && <div className="accordionOpen">{children}</div>}       

      </div>
    </div>
    </MyErrorBoundary>
  );
};

export default ProjectsAccordion;

ProjectsAccordion.propTypes = {
  children: PropTypes.instanceOf(Object),
};
